/* Lists: hearts on product cards, "Add to list" on the product page, the
   Lists page, and a guest list kept in the browser until sign-in.
   Signed in, every change goes to Qortex (window.lumLists.endpoint) with the
   customer id and the token Qortex wrote onto the customer; Qortex mirrors
   the result onto the customer record, so the next page load renders it in
   Liquid. Signed out, the list lives in localStorage ("lumGuestList") and is
   merged into the account the first time the person signs in. */
(function () {
  'use strict';
  var cfg = window.lumLists || {};
  var signedIn = !!(cfg.customer && cfg.token);
  // Signed in, but Qortex has not written this account's token yet (a new
  // account; a few minutes): nothing is saved as a guest, the person is told.
  var pending = !!(cfg.customer && !cfg.token);
  var SETUP_MSG = 'Your account is still being set up for lists; try again in a few minutes.';
  var GUEST_KEY = 'lumGuestList';
  var state = cfg.state && Array.isArray(cfg.state.lists) ? cfg.state : { v: 1, lists: [], products: [], count: 0 };
  var guest = readGuest();

  /* ── state helpers ─────────────────────────────────────────────── */
  function readGuest() {
    try { var g = JSON.parse(localStorage.getItem(GUEST_KEY) || 'null'); if (g && Array.isArray(g.items)) return g; } catch (e) { /* no storage */ }
    return { items: [] };
  }
  function writeGuest() { try { localStorage.setItem(GUEST_KEY, JSON.stringify(guest)); } catch (e) { /* no storage */ } }
  function savedIds() {
    var ids = {};
    if (signedIn) { state.lists.forEach(function (l) { (l.items || []).forEach(function (it) { ids[String(it.p)] = true; }); }); }
    else guest.items.forEach(function (it) { ids[String(it.id)] = true; });
    return ids;
  }
  function count() { return signedIn ? (state.count || 0) : guest.items.length; }
  function defaultList() { return state.lists.filter(function (l) { return l['default']; })[0] || state.lists[0] || null; }
  function listsHolding(pid) { return state.lists.filter(function (l) { return (l.items || []).some(function (it) { return String(it.p) === String(pid); }); }); }

  /* ── API: one call at a time, so answers never land out of order ── */
  var queue = Promise.resolve();
  var lastSynced = true;
  function api(action, args) {
    var run = function () {
      return fetch(cfg.endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit',
        body: JSON.stringify({ shop: cfg.shop, customer: cfg.customer, token: cfg.token, action: action, args: args || {} })
      }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || ('request failed (' + r.status + ')')); lastSynced = j.synced !== false; return j.state; }); })
        .then(function (s) { state = s; return s; });
    };
    var p = queue.then(run, run);
    queue = p.catch(function () {});
    return p;
  }
  /* After a change that reshapes the page: reload when Shopify has the new
     state, otherwise say the page will catch up (the cron re-mirrors). */
  function reloadOrNote() {
    if (lastSynced) { setTimeout(function () { location.reload(); }, 400); }
    else toast('Saved. This page will catch up in a few minutes.');
  }

  /* ── UI bits ───────────────────────────────────────────────────── */
  var toastEl;
  function toast(msg, linkText, href) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'lum-ltoast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '';
    toastEl.appendChild(document.createTextNode(msg + ' '));
    if (linkText) { var a = document.createElement('a'); a.href = href; a.textContent = linkText; toastEl.appendChild(a); }
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
  }
  function paintHearts(root) {
    var ids = savedIds();
    (root || document).querySelectorAll('[data-list-heart]').forEach(function (b) {
      var on = !!ids[String(b.getAttribute('data-list-heart'))];
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Saved to your list. Remove?' : 'Save to list');
    });
    document.querySelectorAll('[data-lists-count]').forEach(function (el) { var n = count(), v = n ? String(n) : ''; if (el.textContent !== v) el.textContent = v; if (el.hidden !== !n) el.hidden = !n; });
    document.querySelectorAll('[data-list-add]').forEach(function (b) {
      var on = !!ids[String(b.getAttribute('data-list-add'))];
      b.classList.toggle('is-on', on);
      var label = b.querySelector('[data-list-add-label]'); if (label) label.textContent = on ? 'Saved to list' : 'Add to list';
    });
  }

  /* ── heart on a card ───────────────────────────────────────────── */
  function toggleHeart(btn) {
    var pid = btn.getAttribute('data-list-heart'), handle = btn.getAttribute('data-handle');
    var on = btn.classList.contains('is-on');
    if (pending) { toast(SETUP_MSG); return; }
    btn.disabled = true;
    if (signedIn) {
      api(on ? 'remove' : 'add', { product_gid: pid }).then(function () {
        paintHearts();
        // On the Lists page an unhearted card goes (it came off every list).
        if (on) { var item = btn.closest('[data-list-item]'); if (item) { item.remove(); refreshCounts(); } }
        toast(on ? 'Removed from your lists.' : 'Saved to your list.', on ? '' : 'View list', cfg.listsUrl);
      }).catch(function (e) { toast(e.message || 'Could not save that.'); }).then(function () { btn.disabled = false; });
    } else {
      if (on) guest.items = guest.items.filter(function (it) { return String(it.id) !== String(pid); });
      else guest.items.unshift({ id: pid, handle: handle, at: new Date().toISOString().slice(0, 10) });
      writeGuest(); paintHearts(); btn.disabled = false;
      toast(on ? 'Removed from your list.' : 'Saved to your list (on this device).', on ? '' : 'Sign in to keep it', cfg.loginUrl);
    }
  }

  /* ── "Add to list" picker on the product page ──────────────────── */
  function openPicker(btn) {
    var pid = btn.getAttribute('data-list-add'), handle = btn.getAttribute('data-handle');
    var box = document.querySelector('[data-list-picker]'); if (!box) return;
    if (pending) { toast(SETUP_MSG); return; }
    if (!signedIn) {
      var inGuest = guest.items.some(function (it) { return String(it.id) === String(pid); });
      if (inGuest) guest.items = guest.items.filter(function (it) { return String(it.id) !== String(pid); });
      else guest.items.unshift({ id: pid, handle: handle, at: new Date().toISOString().slice(0, 10) });
      writeGuest(); paintHearts();
      toast(inGuest ? 'Removed from your list.' : 'Saved to your list (on this device).', inGuest ? '' : 'Sign in to keep it', cfg.loginUrl);
      return;
    }
    var holding = listsHolding(pid).map(function (l) { return l.id; });
    var html = '<div class="lum-listpick__head"><strong>Save to</strong><button type="button" class="lum-listpick__close" data-picker-close aria-label="Close">&times;</button></div>';
    if (!state.lists.length) html += '<p class="lum-listpick__empty">You have no lists yet. Your first one is created when you save.</p>';
    html += '<ul class="lum-listpick__lists">';
    state.lists.forEach(function (l) {
      var on = holding.indexOf(l.id) >= 0;
      html += '<li><label><input type="checkbox" data-picker-list="' + l.id + '"' + (on ? ' checked' : '') + '> <span>' + esc(l.name) + '</span> <small>' + (l.n || 0) + '</small></label></li>';
    });
    html += '</ul>';
    if (!state.lists.length) html += '<button type="button" class="lum-btn lum-btn--primary lum-listpick__save" data-picker-quick>Save to My list</button>';
    html += '<form class="lum-listpick__new" data-picker-new><input type="text" name="name" maxlength="60" placeholder="New list name" aria-label="New list name"><button type="submit" class="lum-btn lum-btn--outline">Create &amp; save</button></form>';
    box.innerHTML = html; box.hidden = false; box.setAttribute('data-pid', pid);
    box.querySelector('input, button') && box.querySelector('input, button').focus();
  }
  function closePicker() { var box = document.querySelector('[data-list-picker]'); if (box) { box.hidden = true; box.innerHTML = ''; } }

  /* ── Lists page ────────────────────────────────────────────────── */
  function money(cents) { try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2); } catch (e) { return '$' + (cents / 100).toFixed(2); } }
  function renderGuestPage(root) {
    var grid = root.querySelector('[data-guest-grid]'); if (!grid) return;
    if (!guest.items.length) { root.querySelector('[data-guest-empty]').hidden = false; grid.innerHTML = ''; return; }
    root.querySelector('[data-guest-empty]').hidden = true;
    grid.innerHTML = '';
    guest.items.forEach(function (it) {
      if (!it.handle) return;
      var card = document.createElement('div'); card.className = 'lum-glist__card'; card.setAttribute('data-guest-item', it.id);
      card.innerHTML = '<a class="lum-glist__img" href="/products/' + encodeURIComponent(it.handle) + '"></a><div class="lum-glist__body"><a class="lum-glist__title" href="/products/' + encodeURIComponent(it.handle) + '">Loading…</a><div class="lum-glist__price"></div><div class="lum-glist__row"><button type="button" class="lum-btn lum-btn--primary" data-guest-add>Add to cart</button><button type="button" class="lum-link" data-guest-remove>Remove</button></div></div>';
      grid.appendChild(card);
      fetch('/products/' + encodeURIComponent(it.handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) { card.querySelector('.lum-glist__title').textContent = 'This product is no longer available'; card.querySelector('[data-guest-add]').disabled = true; return; }
        card.querySelector('.lum-glist__title').textContent = p.title;
        if (p.featured_image) { var img = document.createElement('img'); img.src = p.featured_image; img.alt = ''; img.loading = 'lazy'; card.querySelector('.lum-glist__img').appendChild(img); }
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        card.querySelector('.lum-glist__price').textContent = v ? money(v.price) : '';
        var add = card.querySelector('[data-guest-add]');
        if (!v || !v.available) { add.disabled = true; add.textContent = 'Out of stock'; } else add.setAttribute('data-variant', v.id);
      }).catch(function () { card.querySelector('.lum-glist__title').textContent = 'Could not load this product'; });
    });
  }
  /* Adds go through a hidden add-to-cart form so the theme's cart script does
     what it does for every add: refreshes the drawer and opens it. One form
     per product; "Add all" submits them one after another. */
  function addViaTheme(variantId) {
    return new Promise(function (resolve, reject) {
      var f = document.createElement('form'); f.action = '/cart/add'; f.method = 'post'; f.hidden = true; f.setAttribute('data-lum-list-add', '1');
      f.innerHTML = '<input type="hidden" name="id" value="' + Number(variantId) + '"><input type="hidden" name="quantity" value="1"><button type="submit">Add</button>';
      document.body.appendChild(f);
      var done = false, timer = setTimeout(function () { finish(new Error('The cart did not answer; please try again.')); }, 8000);
      function finish(err) { if (done) return; done = true; clearTimeout(timer); document.removeEventListener('luminate:cart-add-success', onOk); document.removeEventListener('luminate:cart-rendered', onRendered); if (f.parentNode) f.parentNode.removeChild(f); err ? reject(err) : resolve(); }
      // The cart script dispatches the success event before it has re-rendered
      // the drawer and is ready for another add; wait for the render too.
      var okSeen = false;
      function onOk(ev) { var d = ev.detail && ev.detail.item; if (!d || String(d.variant_id) === String(variantId)) { okSeen = true; setTimeout(function () { finish(); }, 1500); } }
      function onRendered() { if (okSeen) { document.removeEventListener('luminate:cart-rendered', onRendered); setTimeout(function () { finish(); }, 250); } }
      document.addEventListener('luminate:cart-add-success', onOk);
      document.addEventListener('luminate:cart-rendered', onRendered);
      setTimeout(function () { try { f.requestSubmit(); } catch (e) { finish(e); } }, 50);
    });
  }
  function addToCart(items) {
    var chain = Promise.resolve();
    items.forEach(function (it) { chain = chain.then(function () { return addViaTheme(it.id); }); });
    return chain;
  }

  /* ── wiring ────────────────────────────────────────────────────── */
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest ? ev.target : null; if (!t) return;
    var heart = t.closest('[data-list-heart]');
    if (heart) { ev.preventDefault(); ev.stopPropagation(); toggleHeart(heart); return; }
    var add = t.closest('[data-list-add]');
    if (add) { ev.preventDefault(); var box = document.querySelector('[data-list-picker]'); if (box && !box.hidden) closePicker(); else openPicker(add); return; }
    if (t.closest('[data-picker-close]')) { closePicker(); return; }
    var quick = t.closest('[data-picker-quick]');
    if (quick) { var pid0 = document.querySelector('[data-list-picker]').getAttribute('data-pid'); quick.disabled = true; api('add', { product_gid: pid0 }).then(function () { closePicker(); paintHearts(); toast('Saved to My list.', 'View list', cfg.listsUrl); }).catch(function (e) { toast(e.message); quick.disabled = false; }); return; }
    var rm = t.closest('[data-list-remove]');
    if (rm) {
      var item = rm.closest('[data-list-item]'); var lid = rm.getAttribute('data-list-id'); var pidr = rm.getAttribute('data-product-id');
      rm.disabled = true;
      api('remove', { product_gid: pidr, list_id: lid }).then(function () { if (item) item.remove(); paintHearts(); refreshCounts(); }).catch(function (e) { toast(e.message); rm.disabled = false; });
      return;
    }
    var del = t.closest('[data-list-delete]');
    if (del) { if (!confirm('Delete this list?')) return; del.disabled = true; api('delete', { list_id: del.getAttribute('data-list-id') }).then(reloadOrNote).catch(function (e) { toast(e.message); del.disabled = false; }); return; }
    var addAll = t.closest('[data-list-addall]');
    if (addAll) {
      var block = addAll.closest('[data-list-block]'); var items = [];
      block.querySelectorAll('[data-list-item][data-variant]').forEach(function (el) { if (el.getAttribute('data-available') === 'true') items.push({ id: Number(el.getAttribute('data-variant')), quantity: 1 }); });
      if (!items.length) { toast('Nothing in this list is in stock right now.'); return; }
      addAll.disabled = true;
      addToCart(items).then(function () { toast(items.length + (items.length === 1 ? ' product added to your cart.' : ' products added to your cart.')); }).catch(function (e) { toast(e.message); }).then(function () { addAll.disabled = false; });
      return;
    }
    var gRemove = t.closest('[data-guest-remove]');
    if (gRemove) { var gc = gRemove.closest('[data-guest-item]'); guest.items = guest.items.filter(function (it) { return String(it.id) !== String(gc.getAttribute('data-guest-item')); }); writeGuest(); gc.remove(); paintHearts(); var root = document.querySelector('[data-lists-page]'); if (root && !guest.items.length) renderGuestPage(root); return; }
    var gAdd = t.closest('[data-guest-add]');
    if (gAdd && gAdd.getAttribute('data-variant')) { gAdd.disabled = true; addToCart([{ id: Number(gAdd.getAttribute('data-variant')), quantity: 1 }]).then(function () { toast('Added to your cart.'); }).catch(function (e) { toast(e.message); }).then(function () { gAdd.disabled = false; }); return; }
  });

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f.matches('[data-picker-new]')) {
      ev.preventDefault(); var name = f.name.value.trim(); if (!name) return;
      var pid = document.querySelector('[data-list-picker]').getAttribute('data-pid');
      var before = state.lists.map(function (x) { return x.id; });
      api('create', { name: name }).then(function (s) { var l = s.lists.filter(function (x) { return before.indexOf(x.id) < 0; })[0]; if (!l) throw new Error('The list was not created.'); return api('add', { product_gid: pid, list_id: l.id }); })
        .then(function () { closePicker(); paintHearts(); toast('Saved to ' + name + '.', 'View list', cfg.listsUrl); }).catch(function (e) { toast(e.message); });
      return;
    }
    if (f.matches('[data-list-new]')) {
      ev.preventDefault(); var n2 = f.name.value.trim(); if (!n2) return;
      api('create', { name: n2 }).then(reloadOrNote).catch(function (e) { toast(e.message); });
      return;
    }
    if (f.matches('[data-list-rename]')) {
      ev.preventDefault(); var n3 = f.name.value.trim(); if (!n3) return;
      api('rename', { list_id: f.getAttribute('data-list-id'), name: n3 }).then(reloadOrNote).catch(function (e) { toast(e.message); });
      return;
    }
  });

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t.matches('[data-picker-list]')) {
      var pid = document.querySelector('[data-list-picker]').getAttribute('data-pid'); var lid = t.getAttribute('data-picker-list'); var on = t.checked;
      t.disabled = true;
      api(on ? 'add' : 'remove', { product_gid: pid, list_id: lid }).then(function () { paintHearts(); var l = state.lists.filter(function (x) { return x.id === lid; })[0]; toast(on ? 'Saved to ' + (l ? l.name : 'your list') + '.' : 'Removed.', on ? 'View list' : '', cfg.listsUrl); })
        .catch(function (e) { toast(e.message); t.checked = !on; }).then(function () { t.disabled = false; });
      return;
    }
    if (t.matches('[data-list-move]')) {
      var to = t.value; if (!to) return;
      var item = t.closest('[data-list-item]');
      api('move', { product_gid: t.getAttribute('data-product-id'), from: t.getAttribute('data-list-id'), to: to }).then(reloadOrNote).catch(function (e) { toast(e.message); t.value = ''; if (item) item.classList.remove('is-busy'); });
      if (item) item.classList.add('is-busy');
    }
  });

  function refreshCounts() {
    document.querySelectorAll('[data-list-block]').forEach(function (b) { var n = b.querySelectorAll('[data-list-item]').length; var c = b.querySelector('[data-list-n]'); if (c) c.textContent = n + (n === 1 ? ' product' : ' products'); var e = b.querySelector('[data-list-empty]'); if (e) e.hidden = n > 0; });
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function boot() {
    paintHearts();
    // Cards added later (rails, search results, quick views).
    var raf = 0;
    new MutationObserver(function (muts) {
      var need = false;
      muts.forEach(function (m) { for (var i = 0; i < m.addedNodes.length && !need; i++) { var n = m.addedNodes[i]; if (n.nodeType === 1 && (n.matches('[data-list-heart]') || n.querySelector('[data-list-heart]'))) need = true; } });
      if (need && !raf) raf = requestAnimationFrame(function () { raf = 0; paintHearts(); });
    }).observe(document.body, { childList: true, subtree: true });
    var root = document.querySelector('[data-lists-page]');
    if (root) { if (signedIn) refreshCounts(); else if (!pending) renderGuestPage(root); }
    // Signed in with a guest list from before: keep it.
    var mergeTried = false; try { mergeTried = sessionStorage.getItem('lumGuestMerge') === '1'; } catch (e) { /* no storage */ }
    if (signedIn && guest.items.length && !mergeTried) {
      var gids = guest.items.map(function (it) { return it.id; });
      try { sessionStorage.setItem('lumGuestMerge', '1'); } catch (e) { /* no storage */ }
      api('merge', { product_gids: gids }).then(function (s) {
        var landed = savedIds(); var kept = guest.items.filter(function (it) { return !landed[String(it.id)]; });
        var n = guest.items.length - kept.length; guest = { items: kept }; writeGuest(); paintHearts();
        if (n) toast(n + (n === 1 ? ' product from this device was added to your list.' : ' products from this device were added to your list.'), 'View list', cfg.listsUrl);
        if (root && n) reloadOrNote();
      }).catch(function () { /* next session */ });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* ── Waiting for restock: the website's back-in-stock requests for this
     account's email (Qortex, action "waiting"); the block stays hidden when
     there are none or the call fails. Not through api(): it carries no state. ── */
  var waitEl = document.querySelector('[data-waiting]');
  if (waitEl && signedIn) {
    fetch(cfg.endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit',
      body: JSON.stringify({ shop: cfg.shop, customer: cfg.customer, token: cfg.token, action: 'waiting', args: {} })
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var w = (j && j.ok && Array.isArray(j.waiting)) ? j.waiting : [];
      if (!w.length) return;
      var n = waitEl.querySelector('[data-waiting-n]'), ul = waitEl.querySelector('[data-waiting-list]');
      if (n) n.textContent = w.length === 1 ? "You're waiting on 1 product" : "You're waiting on " + w.length + ' products';
      if (ul) w.forEach(function (it) {
        var li = document.createElement('li');
        var ok = typeof it.url === 'string' && /^https:\/\/(www\.)?luminateco\.ca\/products\/[a-z0-9-]+$/.test(it.url);
        var node = ok ? document.createElement('a') : document.createElement('span');
        if (ok) node.href = it.url;
        node.textContent = String(it.name || 'A product');
        li.appendChild(node); ul.appendChild(li);
      });
      waitEl.hidden = false;
    }).catch(function () { /* stays hidden */ });
  }
})();
